'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_ff399ec7 = {"container":"ControlGroup_module_container__0547b8e6"};
require("../../../assets/cjs/components/ControlGroup/src/ControlGroup~-9zMxKX8.css");

exports.default = modules_ff399ec7;
//# sourceMappingURL=ControlGroup.module.less.js.map
